import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DreRoutingModule } from './dre-routing.module';
import { DreListarComponent } from './dre-listar/dre-listar.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { MessagesModule } from 'primeng/messages';
import { ConfirmationService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';


@NgModule({
  declarations: [
    DreListarComponent
  ],
  imports: [
    CommonModule,
    DreRoutingModule,
    FormsModule,
    TableModule,
    ConfirmDialogModule,
    MessagesModule,
    InputTextModule,
    DropdownModule,
    TooltipModule,
    CalendarModule
  ],
  providers: [ConfirmationService]
})
export class DreModule { }
